import {    TASK_HISTORY_REQUESTED,
    TASK_HISTORY_RECEIVED,
    TASK_HISTORY_ERROR,

    } from "../actions/bpmnTaskHistory";
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
*
* @param {RequestResult} state
* @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
* @return {RequestResult}
*/
export const taskHistory = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

switch (action.type) {
   case TASK_HISTORY_REQUESTED:
       return new RequestResult(RequestState.getInstanceLoading(), state.data);
   case TASK_HISTORY_RECEIVED:
       return new RequestResult(RequestState.getInstanceDone(), action.taskHistory, action.receivedAt);
   case TASK_HISTORY_ERROR:
       return new RequestResult(
           RequestState.getInstanceError(
               action.errorResponseStatusCode,
               action.errorResponseMessage ? action.errorResponseMessage : null
           ),
           state.getData()
       );
 
   default:
       return state
}
};
